import type { InspectionWithValues } from "../../models/Inspection";
import type { RollingSummaryResult } from "../../models/RollingSummary";

interface SummaryAverageRow {
	__average: true;
	SectionName: string;
	HeatName: string;
	Comments: string;
	rolling: RollingSummaryResult;
}
export type SummaryRow = InspectionWithValues | SummaryAverageRow;
export const isAverageRow = (row: SummaryRow): row is SummaryAverageRow =>
	"__average" in row;

export const createAverageRow = (
	rolling: RollingSummaryResult,
	sectionLabel?: string,
): SummaryAverageRow => ({
	__average: true,
	SectionName: sectionLabel ?? "-",
	HeatName: `${rolling.summary?.Heats ?? 0} heats`,
	Comments: `${rolling.summary?.Samples ?? 0} samples`,
	rolling,
});
